import { PractitionerInfoComponent } from './practitioner-info.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ModalsModule } from '../../../../widgets/entry-components/modal/modals.module';

@NgModule({
  declarations: [PractitionerInfoComponent],
  imports: [
    CommonModule, TranslateModule, IonicModule,
    FormsModule, ModalsModule
  ],
  exports: [PractitionerInfoComponent]
})
export class PractitionerInfoModule { }
